	
function ItemExists(items, id) {
	for (let i = 0; i < items.length; i++) {
    if (items[i] == id) return true;
  }
  return false;
}

function GetIdCsv() {
	  var items = [];
  
    var game1id = document.getElementById('ddlGame1').value;
    if (game1id > 0 && !ItemExists(items, game1id)) items.push(game1id);

    var game2id = document.getElementById('ddlGame2').value;
    if (game2id > 0 && !ItemExists(items, game2id)) items.push(game2id);

    var game3id = document.getElementById('ddlGame3').value;
    if (game3id > 0 && !ItemExists(items, game3id)) items.push(game3id);
    
    var game4id = document.getElementById('ddlGame4').value;
    if (game4id > 0 && !ItemExists(items, game4id)) items.push(game4id);

    var game5id = document.getElementById('ddlGame5').value;
    if (game5id > 0 && !ItemExists(items, game5id)) items.push(game5id);

		//items.push(342942);
		//items.push(31260);
		//items.push(391137);
		
    if (items.length < 3) {
    	alert('ERROR: You must select at least 3 different games for good recommendations.');
    	return;
    }
    var csv = "";
    for (let i = 0; i < items.length; i++)
       csv += "," + items[i];
    
    return csv.substring(1, 999);
}
	
async function handleMyButtonClick(doc) {
  var csv = GetIdCsv();
  if (csv == '')
    return;
  var apiUrl = 'https://api.boardgamehelpers.com/api/WhatShouldIBuyNext/GetRecommendationsWithDefaults/wsibnapi5972;' + csv;
  //alert(apiUrl);

  //doc.getElementById("RecommendationsDiv").innerHTML = "<a target=\"_blank\" href=\"" + apiUrl + "\">Click here to call the API</a><br />";
    
  doc.body.style.cursor = 'wait';
  var response = await callRecommendationsAPI(apiUrl);
  //doc.getElementById("RecommendationsDiv2").innerHTML = "API Response: " + response;

  var jsonObject = JSON.parse(response);
  var outputHtml = '<span style="font-weight: bold; text-decoration: underline;">Recommended Games</span><br />';
  outputHtml += "<ol>";
  for (var i = 0; i < jsonObject.RecommendationCount; i++) {
    var game = jsonObject.RecommendatedGames[i];
     outputHtml += '<li>' + game.Name + ' (<a href="https://boardgamegeek.com/boardgame/' + game.BGGId + '" target="_blank">view on BGG</a>)</li>';
  }
  outputHtml += "</ol>";
  doc.getElementById("RecommendationsDiv").innerHTML = outputHtml;
  doc.body.style.cursor = 'default';
}
  
async function callRecommendationsAPI(apiUrl) {
  return   fetch(apiUrl)
        .then((response) => { 
            return response.json().then((data) => {
                console.log(data);
                return data;
            }).catch((err) => {
                console.log(err);
            }) 
        });
}

window.addEventListener("load",function(){
    loadDropDownList("ddlGame1");
    loadDropDownList("ddlGame2");
    loadDropDownList("ddlGame3");
    loadDropDownList("ddlGame4");
    loadDropDownList("ddlGame5");
},false);

function addItemToDropDownList(list, value, text) {
	 var listItem = document.createElement("option");
   listItem.value= value;
   listItem.innerHTML = text;
	 list.appendChild(listItem);
}
                                                                       
function loadDropDownList(listName) {
	var list = document.getElementById(listName);
addItemToDropDownList(list, -1, '- select a game -');
addItemToDropDownList(list, 177590, '13 Days: The Cuban Missile Crisis, 1962 (2016)');
addItemToDropDownList(list, 128996, '1775: Rebellion (2013)');
addItemToDropDownList(list, 94246, '1812: The Invasion of Canada (2012)');
addItemToDropDownList(list, 63170, '1817 (2010)');
addItemToDropDownList(list, 421, '1830: Railways & Robber Barons (1986)');
addItemToDropDownList(list, 17405, '1846: The Race for the Midwest (2005)');
addItemToDropDownList(list, 3097, '1849: The Game of Sicilian Railways (1998)');
addItemToDropDownList(list, 66837, '1862: Railway Mania in the Eastern Counties (2013)');
addItemToDropDownList(list, 253608, '18Chesapeake (2018)');
addItemToDropDownList(list, 27708, '1960: The Making of the President (2007)');
addItemToDropDownList(list, 26997, '1989: Dawn of Freedom (2012)');
addItemToDropDownList(list, 192458, '51st State: Master Set (2016)');
addItemToDropDownList(list, 207830, '5-Minute Dungeon (2017)');
addItemToDropDownList(list, 68448, '7 Wonders (2010)');
addItemToDropDownList(list, 173346, '7 Wonders Duel (2015)');
addItemToDropDownList(list, 346703, '7 Wonders: Architects (2021)');
addItemToDropDownList(list, 286063, 'The 7th Citadel (2024)');
addItemToDropDownList(list, 180263, 'The 7th Continent (2017)');
addItemToDropDownList(list, 302260, 'Abandon All Artichokes (2020)');
addItemToDropDownList(list, 172818, 'Above and Below (2015)');
addItemToDropDownList(list, 155987, 'Abyss (2014)');
addItemToDropDownList(list, 5, 'Acquire (1963)');
addItemToDropDownList(list, 202408, 'Adrenaline (2016)');
addItemToDropDownList(list, 243, 'Advanced Squad Leader (1985)');
addItemToDropDownList(list, 183231, 'Adventure Land (2015)');
addItemToDropDownList(list, 191189, 'Aeon`s End (2016)');
addItemToDropDownList(list, 241451, 'Aeon`s End: Legacy (2019)');
addItemToDropDownList(list, 270633, 'Aeon`s End: The New Age (2019)');
addItemToDropDownList(list, 218417, 'Aeon`s End: War Eternal (2017)');
addItemToDropDownList(list, 200511, 'After the Empire (2021)');
addItemToDropDownList(list, 264647, 'Age of Civilization (2019)');
addItemToDropDownList(list, 22545, 'Age of Empires III: The Age of Discovery (2007)');
addItemToDropDownList(list, 330950, 'Age of Galaxy (2022)');
addItemToDropDownList(list, 383179, 'Age of Innovation (2023)');
addItemToDropDownList(list, 4098, 'Age of Steam (2002)');
addItemToDropDownList(list, 155695, 'Age of War (2014)');
addItemToDropDownList(list, 270871, 'Agemonia (2024)');
addItemToDropDownList(list, 31260, 'Agricola (2007)');
addItemToDropDownList(list, 119890, 'Agricola: All Creatures Big and Small (2012)');
addItemToDropDownList(list, 247367, 'Air, Land, & Sea (2019)');
addItemToDropDownList(list, 90419, 'Airlines Europe (2011)');
addItemToDropDownList(list, 357563, 'Akropolis (2022)');
addItemToDropDownList(list, 161970, 'Alchemists (2014)');
addItemToDropDownList(list, 6249, 'Alhambra (2003)');
addItemToDropDownList(list, 48726, 'Alien Frontiers (2010)');
addItemToDropDownList(list, 234487, 'Altiplano (2017)');
addItemToDropDownList(list, 1608, 'Ambush! (1983)');
addItemToDropDownList(list, 137408, 'Amerigo (2013)');
addItemToDropDownList(list, 110277, 'Among the Stars (2012)');
addItemToDropDownList(list, 5404, 'Amun-Re (2003)');
addItemToDropDownList(list, 29934, 'Amyitis (2007)');
addItemToDropDownList(list, 185343, 'Anachrony (2017)');
addItemToDropDownList(list, 91080, 'Andean Abyss (2012)');
addItemToDropDownList(list, 39339, 'Android (2008)');
addItemToDropDownList(list, 124742, 'Android: Netrunner (2012)');
addItemToDropDownList(list, 358661, 'Andromeda`s Edge (2024)');
addItemToDropDownList(list, 285967, 'Ankh: Gods of Egypt (2021)');
addItemToDropDownList(list, 311193, 'Anno 1800: The Board Game (2020)');
addItemToDropDownList(list, 166857, 'Antike II (2014)');
addItemToDropDownList(list, 13122, 'Antiquity (2004)');
addItemToDropDownList(list, 400314, 'Apiary (2023)');
addItemToDropDownList(list, 159508, 'AquaSphere (2014)');
addItemToDropDownList(list, 283393, 'Aquatica (2019)');
addItemToDropDownList(list, 140934, 'Arboretum (2015)');
addItemToDropDownList(list, 155068, 'Arcadia Quest (2014)');
addItemToDropDownList(list, 105551, 'Archipelago (2012)');
addItemToDropDownList(list, 236457, 'Architects of the West Kingdom (2018)');
addItemToDropDownList(list, 359871, 'Arcs (2024)');
addItemToDropDownList(list, 144797, 'Argent: The Consortium (2015)');
addItemToDropDownList(list, 230889, 'Aristeia! (2017)');
addItemToDropDownList(list, 342942, 'Ark Nova (2021)');
addItemToDropDownList(list, 25643, 'Arkadia (2006)');
addItemToDropDownList(list, 15987, 'Arkham Horror (2005)');
addItemToDropDownList(list, 205637, 'Arkham Horror: The Card Game (2016)');
addItemToDropDownList(list, 359609, 'Arkham Horror: The Card Game (Revised Core Set) (2021)');
addItemToDropDownList(list, 154825, 'Arkwright (2014)');
addItemToDropDownList(list, 254713, 'The Artemis Project (2019)');
addItemToDropDownList(list, 72991, 'Asara (2010)');
addItemToDropDownList(list, 69789, 'Ascension: Deckbuilding Game (2010)');
addItemToDropDownList(list, 95064, 'Ascension: Return of the Fallen (2011)');
addItemToDropDownList(list, 108784, 'Ascension: Storm of Souls (2011)');
addItemToDropDownList(list, 167400, 'Ashes Reborn: Rise of the Phoenixborn (2015)');
addItemToDropDownList(list, 39683, 'At the Gates of Loyang (2009)');
addItemToDropDownList(list, 19999, 'Aton (2005)');
addItemToDropDownList(list, 8051, 'Attika (2003)');
addItemToDropDownList(list, 176544, 'Automania (2015)');
addItemToDropDownList(list, 39351, 'Automobile (2009)');
addItemToDropDownList(list, 180680, 'Automobiles (2016)');
addItemToDropDownList(list, 231581, 'AuZtralia (2018)');
addItemToDropDownList(list, 494, 'Ave Caesar (1989)');
addItemToDropDownList(list, 188866, 'Awkward Guests: The Walton Case (2016)');
addItemToDropDownList(list, 98, 'Axis & Allies (1981)');
addItemToDropDownList(list, 61692, 'Axis & Allies: Europe 1940 (2010)');
addItemToDropDownList(list, 55829, 'Axis & Allies: Pacific 1940 (2009)');
addItemToDropDownList(list, 230802, 'Azul (2017)');
addItemToDropDownList(list, 256226, 'Azul: Stained Glass of Sintra (2018)');
addItemToDropDownList(list, 287954, 'Azul: Summer Pavilion (2019)');
addItemToDropDownList(list, 2397, 'Backgammon (-3000)');
addItemToDropDownList(list, 5716, 'Balloon Cup (2003)');
addItemToDropDownList(list, 1231, 'Bandu (1987)');
addItemToDropDownList(list, 3955, 'BANG! (2002)');
addItemToDropDownList(list, 219513, 'Bärenpark (2017)');
addItemToDropDownList(list, 167513, 'Barony (2015)');
addItemToDropDownList(list, 251247, 'Barrage (2019)');
addItemToDropDownList(list, 151022, 'Baseball Highlights: 2045 (2015)');
addItemToDropDownList(list, 760, 'Battle Line (2000)');
addItemToDropDownList(list, 89409, 'BattleCON: War of Indines (2012)');
addItemToDropDownList(list, 25417, 'BattleLore (2006)');
addItemToDropDownList(list, 67492, 'Battles of Westeros (2010)');
addItemToDropDownList(list, 37111, 'Battlestar Galactica: The Board Game (2008)');
addItemToDropDownList(list, 1540, 'BattleTech (1985)');
addItemToDropDownList(list, 165950, 'Beasty Bar (2014)');
addItemToDropDownList(list, 432, 'Beat the Heat (1994)');
addItemToDropDownList(list, 10547, 'Betrayal at House on the Hill (2004)');
addItemToDropDownList(list, 240196, 'Betrayal Legacy (2018)');
addItemToDropDownList(list, 258036, 'Between Two Castles of Mad King Ludwig (2018)');
addItemToDropDownList(list, 168435, 'Between Two Cities (2015)');
addItemToDropDownList(list, 317985, 'Beyond the Sun (2020)');
addItemToDropDownList(list, 34219, 'Biblios (2007)');
addItemToDropDownList(list, 171233, 'The Big Book of Madness (2015)');
addItemToDropDownList(list, 277927, 'Bites (2020)');
addItemToDropDownList(list, 323612, 'Bitoku (2021)');
addItemToDropDownList(list, 157403, 'Black Fleet (2014)');
addItemToDropDownList(list, 420805, 'Black Forest (2024)');
addItemToDropDownList(list, 156858, 'Black Orchestra (2016)');
addItemToDropDownList(list, 262215, 'Blackout: Hong Kong (2018)');
addItemToDropDownList(list, 258210, 'Blitzkrieg!: World War Two in 20 Minutes (2019)');
addItemToDropDownList(list, 2453, 'Blokus (2000)');
addItemToDropDownList(list, 21550, 'Blokus Trigon (2006)');
addItemToDropDownList(list, 212445, 'Blood Bowl (2016 Edition) (2016)');
addItemToDropDownList(list, 90137, 'Blood Bowl: Team Manager – The Card Game (2011)');
addItemToDropDownList(list, 240980, 'Blood on the Clocktower (2022)');
addItemToDropDownList(list, 170216, 'Blood Rage (2015)');
addItemToDropDownList(list, 195856, 'Bloodborne: The Card Game (2016)');
addItemToDropDownList(list, 180593, 'The Bloody Inn (2015)');
addItemToDropDownList(list, 244331, 'Blue Lagoon (2018)');
addItemToDropDownList(list, 21882, 'Blue Moon City (2006)');
addItemToDropDownList(list, 140933, 'Blueprints (2013)');
addItemToDropDownList(list, 11, 'Bohnanza (1997)');
addItemToDropDownList(list, 304420, 'Bonfire (2020)');
addItemToDropDownList(list, 343905, 'Boonlake (2021)');
addItemToDropDownList(list, 127060, 'Bora Bora (2013)');
addItemToDropDownList(list, 224517, 'Brass: Birmingham (2018)');
addItemToDropDownList(list, 28720, 'Brass: Lancashire (2007)');
addItemToDropDownList(list, 337765, 'Brian Boru: High King of Ireland (2021)');
addItemToDropDownList(list, 2181, 'Bridge (1925)');
addItemToDropDownList(list, 8190, 'The Bridges of Shangri-La (2003)');
addItemToDropDownList(list, 240, 'Britannia (1986)');
addItemToDropDownList(list, 172308, 'Broom Service (2015)');
addItemToDropDownList(list, 136888, 'Bruges (2013)');
addItemToDropDownList(list, 144592, 'Bruxelles 1893 (2013)');
addItemToDropDownList(list, 184921, 'Bunny Kingdom (2017)');
addItemToDropDownList(list, 172081, 'Burgle Bros. (2015)');
addItemToDropDownList(list, 389820, 'Burning Banners (2024)');
addItemToDropDownList(list, 552, 'Bus (1999)');
addItemToDropDownList(list, 171499, 'Cacao (2015)');
addItemToDropDownList(list, 283155, 'Calico (2020)');
addItemToDropDownList(list, 238992, 'Call to Adventure (2019)');
addItemToDropDownList(list, 153938, 'Camel Up (2014)');
addItemToDropDownList(list, 41, 'Can`t Stop (1980)');
addItemToDropDownList(list, 328565, 'Caper: Europe (2022)');
addItemToDropDownList(list, 159503, 'The Captain Is Dead (2014)');
addItemToDropDownList(list, 171131, 'Captain Sonar (2016)');
addItemToDropDownList(list, 822, 'Carcassonne (2000)');
addItemToDropDownList(list, 4390, 'Carcassonne: Hunters and Gatherers (2002)');
addItemToDropDownList(list, 147303, 'Carcassonne: South Seas (2013)');
addItemToDropDownList(list, 310873, 'Carnegie (2022)');
addItemToDropDownList(list, 481, 'Carolus Magnus (2000)');
addItemToDropDownList(list, 245934, 'Carpe Diem (2018)');
addItemToDropDownList(list, 39938, 'Carson City (2009)');
addItemToDropDownList(list, 826, 'Cartagena (2000)');
addItemToDropDownList(list, 263918, 'Cartographers (2019)');
addItemToDropDownList(list, 315767, 'Cartographers Heroes (2021)');
addItemToDropDownList(list, 295947, 'Cascadia (2021)');
addItemToDropDownList(list, 43443, 'Castle Panic (2009)');
addItemToDropDownList(list, 84876, 'The Castles of Burgundy (2011)');
addItemToDropDownList(list, 191977, 'The Castles of Burgundy: The Card Game (2016)');
addItemToDropDownList(list, 155426, 'Castles of Mad King Ludwig (2014)');
addItemToDropDownList(list, 345972, 'Cat in the Box: Deluxe Edition (2022)');
addItemToDropDownList(list, 228504, 'Cat Lady (2017)');
addItemToDropDownList(list, 13, 'Catan (1995)');
addItemToDropDownList(list, 220520, 'Caverna: Cave vs Cave (2017)');
addItemToDropDownList(list, 102794, 'Caverna: The Cave Farmers (2013)');
addItemToDropDownList(list, 18602, 'Caylus (2005)');
addItemToDropDownList(list, 27364, 'Caylus Magna Carta (2007)');
addItemToDropDownList(list, 175117, 'Celestia (2015)');
addItemToDropDownList(list, 232832, 'Century: Golem Edition (2017)');
addItemToDropDownList(list, 209685, 'Century: Spice Road (2017)');
addItemToDropDownList(list, 218479, 'Cerebria: The Inside World (2018)');
addItemToDropDownList(list, 172287, 'Champions of Midgard (2015)');
addItemToDropDownList(list, 43111, 'Chaos in the Old World (2009)');
addItemToDropDownList(list, 197376, 'Charterstone (2017)');
addItemToDropDownList(list, 171, 'Chess (1475)');
addItemToDropDownList(list, 214880, 'Chicago 1875: City of the Big Shoulders (2019)');
addItemToDropDownList(list, 163642, 'Chimera Station (2017)');
addItemToDropDownList(list, 18100, 'China (2005)');
addItemToDropDownList(list, 47, 'Chinatown (1999)');
addItemToDropDownList(list, 240567, 'Chocolate Factory (2019)');
addItemToDropDownList(list, 239188, 'Chronicles of Crime (2018)');
addItemToDropDownList(list, 132018, 'Churchill (2015)');
addItemToDropDownList(list, 213266, 'Circle the Wagons (2017)');
addItemToDropDownList(list, 478, 'Citadels (2000)');
addItemToDropDownList(list, 71, 'Civilization (1980)');
addItemToDropDownList(list, 233247, 'Civilization: A New Dawn (2017)');
addItemToDropDownList(list, 400602, 'Civolution (2024)');
addItemToDropDownList(list, 233371, 'Clank! In! Space!: A Deck-Building Adventure (2017)');
addItemToDropDownList(list, 266507, 'Clank! Legacy: Acquisitions Incorporated (2019)');
addItemToDropDownList(list, 201808, 'Clank!: A Deck-Building Adventure (2016)');
addItemToDropDownList(list, 365717, 'Clank!: Catacombs (2022)');
addItemToDropDownList(list, 216132, 'Clans of Caledonia (2017)');
addItemToDropDownList(list, 40765, 'Clash of Cultures (2012)');
addItemToDropDownList(list, 299659, 'Clash of Cultures: Monumental Edition (2021)');
addItemToDropDownList(list, 36932, 'Claustrophobia (2009)');
addItemToDropDownList(list, 272739, 'Clinic: Deluxe Edition (2019)');
addItemToDropDownList(list, 262211, 'Cloudspire (2019)');
addItemToDropDownList(list, 72225, 'CO2 (2012)');
addItemToDropDownList(list, 214887, 'CO2: Second Chance (2018)');
addItemToDropDownList(list, 143515, 'Coal Baron (2013)');
addItemToDropDownList(list, 11971, 'Cockroach Poker (2004)');
addItemToDropDownList(list, 145639, 'Coconuts (2013)');
addItemToDropDownList(list, 178900, 'Codenames (2015)');
addItemToDropDownList(list, 224037, 'Codenames: Duet (2017)');
addItemToDropDownList(list, 198773, 'Codenames: Pictures (2016)');
addItemToDropDownList(list, 314503, 'Codex Naturalis (2021)');
addItemToDropDownList(list, 196526, 'Coffee Roaster (2015)');
addItemToDropDownList(list, 245638, 'Coimbra (2018)');
addItemToDropDownList(list, 192836, 'The Colonists (2016)');
addItemToDropDownList(list, 5782, 'Coloretto (2003)');
addItemToDropDownList(list, 158899, 'Colt Express (2014)');
addItemToDropDownList(list, 21050, 'Combat Commander: Europe (2006)');
addItemToDropDownList(list, 28181, 'Combat Commander: Pacific (2008)');
addItemToDropDownList(list, 14105, 'Commands & Colors: Ancients (2006)');
addItemToDropDownList(list, 62222, 'Commands & Colors: Napoleonics (2010)');
addItemToDropDownList(list, 160010, 'Conan (2016)');
addItemToDropDownList(list, 147151, 'Concept (2013)');
addItemToDropDownList(list, 124361, 'Concordia (2013)');
addItemToDropDownList(list, 256916, 'Concordia Venus (2018)');
addItemToDropDownList(list, 112, 'Condottiere (1995)');
addItemToDropDownList(list, 276042, 'Conspiracy: Abyss Universe (2019)');
addItemToDropDownList(list, 26990, 'Container (2007)');
addItemToDropDownList(list, 269595, 'Copenhagen (2019)');
addItemToDropDownList(list, 98351, 'Core Worlds (2011)');
addItemToDropDownList(list, 39463, 'Cosmic Encounter (2008)');
addItemToDropDownList(list, 119, 'Cosmolancer (1994)');
addItemToDropDownList(list, 204027, 'Cottage Garden (2016)');
addItemToDropDownList(list, 173101, 'Council of 4 (2015)');
addItemToDropDownList(list, 131357, 'Coup (2012)');
addItemToDropDownList(list, 324856, 'The Crew: Mission Deep Sea (2021)');
addItemToDropDownList(list, 284083, 'The Crew: The Quest for Planet Nine (2019)');
addItemToDropDownList(list, 2398, 'Cribbage (1630)');
addItemToDropDownList(list, 128721, 'Crisis (2016)');
addItemToDropDownList(list, 393429, 'Critter Kitchen (2025)');
addItemToDropDownList(list, 521, 'Crokinole (1876)');
addItemToDropDownList(list, 170624, 'Crusaders: Thy Will Be Done (2018)');
addItemToDropDownList(list, 246784, 'Cryptid (2018)');
addItemToDropDownList(list, 139976, 'Cthulhu Wars (2015)');
addItemToDropDownList(list, 253344, 'Cthulhu: Death May Die (2019)');
addItemToDropDownList(list, 30380, 'Cuba (2007)');
addItemToDropDownList(list, 111799, 'Cuba Libre (2013)');
addItemToDropDownList(list, 245476, 'CuBirds (2018)');
addItemToDropDownList(list, 298069, 'Cubitos (2021)');
addItemToDropDownList(list, 143986, 'CV (2013)');
addItemToDropDownList(list, 54998, 'Cyclades (2009)');
addItemToDropDownList(list, 176165, 'Dale of Merchants (2015)');
addItemToDropDownList(list, 191597, 'Dale of Merchants 2 (2016)');
addItemToDropDownList(list, 111124, 'Dark Moon (2011)');
addItemToDropDownList(list, 322289, 'Darwin`s Journey (2023)');
addItemToDropDownList(list, 125678, 'DC Deck-Building Game (2012)');
addItemToDropDownList(list, 29603, 'D-Day at Omaha Beach (2009)');
addItemToDropDownList(list, 101785, 'D-Day Dice (2012)');
addItemToDropDownList(list, 380135, 'Dead Cells: The Rogue-Lite Board Game (2024)');
addItemToDropDownList(list, 149155, 'Dead Man`s Draw (2014)');
addItemToDropDownList(list, 150376, 'Dead of Winter: A Crossroads Game (2014)');
addItemToDropDownList(list, 193037, 'Dead of Winter: The Long Night (2016)');
addItemToDropDownList(list, 276182, 'Dead Reckoning (2022)');
addItemToDropDownList(list, 156129, 'Deception: Murder in Hong Kong (2014)');
addItemToDropDownList(list, 225694, 'Decrypto (2018)');
addItemToDropDownList(list, 169654, 'Deep Sea Adventure (2014)');
addItemToDropDownList(list, 183571, 'Deep Space D-6 (2015)');
addItemToDropDownList(list, 65532, 'Defenders of the Realm (2010)');
addItemToDropDownList(list, 17226, 'Descent: Journeys in the Dark (2005)');
addItemToDropDownList(list, 322708, 'Descent: Legends of the Dark (2021)');
addItemToDropDownList(list, 285192, 'Destinies (2021)');
addItemToDropDownList(list, 223321, 'Detective: A Modern Crime Board Game (2018)');
addItemToDropDownList(list, 218074, 'Detective: City of Angels (2019)');
addItemToDropDownList(list, 162082, 'Deus (2014)');
addItemToDropDownList(list, 15512, 'Diamant (2005)');
addItemToDropDownList(list, 179572, 'Dice City (2015)');
addItemToDropDownList(list, 194594, 'Dice Forge (2017)');
addItemToDropDownList(list, 218121, 'Dice Hospital (2018)');
addItemToDropDownList(list, 216734, 'Dice Throne: Season One (2018)');
addItemToDropDownList(list, 244271, 'Dice Throne: Season Two – Battle Chest (2018)');
addItemToDropDownList(list, 40793, 'Dice Town (2009)');
addItemToDropDownList(list, 1, 'Die Macher (1986)');
addItemToDropDownList(list, 210296, 'DinoGenics (2019)');
addItemToDropDownList(list, 221194, 'Dinosaur Island (2017)');
addItemToDropDownList(list, 483, 'Diplomacy (1959)');
addItemToDropDownList(list, 91312, 'Discworld: Ankh-Morpork (2011)');
addItemToDropDownList(list, 256382, 'Disney Villainous: The Worst Takes it All (2018)');
addItemToDropDownList(list, 127518, 'A Distant Plain (2013)');
addItemToDropDownList(list, 295895, 'Distilled (2023)');
addItemToDropDownList(list, 216497, 'District Noir (2016)');
addItemToDropDownList(list, 39856, 'Dixit (2008)');
addItemToDropDownList(list, 92828, 'Dixit: Odyssey (2011)');
addItemToDropDownList(list, 5737, 'Domaine (2003)');
addItemToDropDownList(list, 62219, 'Dominant Species (2010)');
addItemToDropDownList(list, 36218, 'Dominion (2008)');
addItemToDropDownList(list, 40834, 'Dominion: Intrigue (2009)');
addItemToDropDownList(list, 205317, 'DOOM: The Board Game (2016)');
addItemToDropDownList(list, 370591, 'Dorfromantik: The Board Game (2022)');
addItemToDropDownList(list, 13004, 'The Downfall of Pompeii (2004)');
addItemToDropDownList(list, 215311, 'Downforce (2017)');
addItemToDropDownList(list, 264055, 'Draftosaurus (2019)');
addItemToDropDownList(list, 232219, 'Dragon Castle (2017)');
addItemToDropDownList(list, 194880, 'Dream Home (2016)');
addItemToDropDownList(list, 244916, 'Drop It (2018)');
addItemToDropDownList(list, 36235, 'The Duke (2013)');
addItemToDropDownList(list, 283355, 'Dune (2019)');
addItemToDropDownList(list, 316554, 'Dune: Imperium (2020)');
addItemToDropDownList(list, 397598, 'Dune: Imperium – Uprising (2023)');
addItemToDropDownList(list, 367150, 'Dune: War for Arrakis (2024)');
addItemToDropDownList(list, 45315, 'Dungeon Lords (2009)');
addItemToDropDownList(list, 97207, 'Dungeon Petz (2011)');
addItemToDropDownList(list, 12995, 'Dungeon Twister (2004)');
addItemToDropDownList(list, 66356, 'Dungeons & Dragons: Wrath of Ashardalon Board Game (2011)');
addItemToDropDownList(list, 148203, 'Dutch Blitz (1960)');
addItemToDropDownList(list, 2346, 'DVONN (2001)');
addItemToDropDownList(list, 271055, 'Dwellings of Eldervale (2020)');
addItemToDropDownList(list, 350184, 'Earth (2023)');
addItemToDropDownList(list, 73171, 'Earth Reborn (2010)');
addItemToDropDownList(list, 342900, 'Earthborne Rangers (2023)');
addItemToDropDownList(list, 72125, 'Eclipse: New Dawn for the Galaxy (2011)');
addItemToDropDownList(list, 246900, 'Eclipse: Second Dawn for the Galaxy (2020)');
addItemToDropDownList(list, 58421, 'Egizia (2009)');
addItemToDropDownList(list, 131366, 'Eight-Minute Empire (2012)');
addItemToDropDownList(list, 142326, 'Eight-Minute Empire: Legends (2013)');
addItemToDropDownList(list, 93, 'El Grande (1995)');
addItemToDropDownList(list, 100423, 'Elder Sign (2011)');
addItemToDropDownList(list, 146021, 'Eldritch Horror (2013)');
addItemToDropDownList(list, 10, 'Elfenland (1998)');
addItemToDropDownList(list, 163968, 'Elysium (2015)');
addItemToDropDownList(list, 68425, 'Eminent Domain (2011)');
addItemToDropDownList(list, 11825, 'Empire of the Sun: The Pacific War 1941-1945 (2005)');
addItemToDropDownList(list, 206931, 'Encore! (2016)');
addItemToDropDownList(list, 33160, 'Endeavor (2009)');
addItemToDropDownList(list, 233398, 'Endeavor: Age of Sail (2018)');
addItemToDropDownList(list, 367966, 'Endeavor: Deep Sea (2024)');
addItemToDropDownList(list, 305096, 'Endless Winter: Paleoamericans (2022)');
addItemToDropDownList(list, 142379, 'Escape Plan (2019)');
addItemToDropDownList(list, 253214, 'Escape Tales: The Awakening (2018)');
addItemToDropDownList(list, 113294, 'Escape: The Curse of the Temple (2012)');
addItemToDropDownList(list, 206718, 'Ethnos (2017)');
addItemToDropDownList(list, 133848, 'Euphoria: Build a Better Dystopia (2013)');
addItemToDropDownList(list, 295785, 'Euthia: Torment of Resurrection (2021)');
addItemToDropDownList(list, 199792, 'Everdell (2018)');
addItemToDropDownList(list, 155703, 'Evolution (2014)');
addItemToDropDownList(list, 182134, 'Evolution: Climate (2016)');
addItemToDropDownList(list, 203420, 'EXIT: The Game – The Abandoned Cabin (2016)');
addItemToDropDownList(list, 379078, 'Expeditions (2023)');
addItemToDropDownList(list, 24417, 'Factory Fun (2006)');
addItemToDropDownList(list, 13823, 'Fairy Tale (2004)');
addItemToDropDownList(list, 135779, 'A Fake Artist Goes to New York (2011)');
addItemToDropDownList(list, 260428, 'Fall of Rome (2018)');
addItemToDropDownList(list, 163154, 'Falling Sky: The Gallic Revolt Against Caesar (2016)');
addItemToDropDownList(list, 232918, 'Fallout (2017)');
addItemToDropDownList(list, 216600, 'Fantastic Factories (2019)');
addItemToDropDownList(list, 223040, 'Fantasy Realms (2017)');
addItemToDropDownList(list, 385761, 'Faraway (2023)');
addItemToDropDownList(list, 7805, 'Fearsome Floors (2003)');
addItemToDropDownList(list, 177736, 'A Feast for Odin (2016)');
addItemToDropDownList(list, 163839, 'Feudum (2018)');
addItemToDropDownList(list, 79828, 'A Few Acres of Snow (2011)');
addItemToDropDownList(list, 159675, 'Fields of Arle (2014)');
addItemToDropDownList(list, 22877, 'Fields of Fire (2008)');
addItemToDropDownList(list, 200954, 'Fields of Green (2016)');
addItemToDropDownList(list, 277659, 'Final Girl (2021)');
addItemToDropDownList(list, 40628, 'Finca (2009)');
addItemToDropDownList(list, 144189, 'Fire in the Lake (2014)');
addItemToDropDownList(list, 138161, 'Firefly: The Game (2013)');
addItemToDropDownList(list, 75449, 'Firenze (2010)');
addItemToDropDownList(list, 206941, 'First Class: All Aboard the Orient Express! (2016)');
addItemToDropDownList(list, 352574, 'Fit to Print (2023)');
addItemToDropDownList(list, 157354, 'Five Tribes: The Djinns of Naqala (2014)');
addItemToDropDownList(list, 336986, 'Flamecraft (2022)');
addItemToDropDownList(list, 199478, 'Flamme Rouge (2016)');
addItemToDropDownList(list, 100901, 'Flash Point: Fire Rescue (2011)');
addItemToDropDownList(list, 121297, 'Fleet (2012)');
addItemToDropDownList(list, 420087, 'Flip 7 (2024)');
addItemToDropDownList(list, 175324, 'Fog of Love (2017)');
addItemToDropDownList(list, 175914, 'Food Chain Magnate (2015)');
addItemToDropDownList(list, 172, 'For Sale (1997)');
addItemToDropDownList(list, 833, 'For the People (1998)');
addItemToDropDownList(list, 136063, 'Forbidden Desert (2013)');
addItemToDropDownList(list, 65244, 'Forbidden Island (2010)');
addItemToDropDownList(list, 175155, 'Forbidden Stars (2015)');
addItemToDropDownList(list, 391163, 'Forest Shuffle (2023)');
addItemToDropDownList(list, 302723, 'Forgotten Waters (2020)');
addItemToDropDownList(list, 173, 'Formula Dé (1997)');
addItemToDropDownList(list, 244049, 'Forum Trajanum (2018)');
addItemToDropDownList(list, 412865, 'Foundations of Metropolis (2024)');
addItemToDropDownList(list, 284189, 'Foundations of Rome (2022)');
addItemToDropDownList(list, 221965, 'The Fox in the Forest (2017)');
addItemToDropDownList(list, 140603, 'Francis Drake (2013)');
addItemToDropDownList(list, 119506, 'Freedom: The Underground Railroad (2013)');
addItemToDropDownList(list, 66188, 'Fresco (2010)');
addItemToDropDownList(list, 43570, 'Friday (2011)');
addItemToDropDownList(list, 384213, 'Fromage (2024)');
addItemToDropDownList(list, 295770, 'Frosthaven (2022)');
addItemToDropDownList(list, 311988, 'Frostpunk: The Board Game (2022)');
addItemToDropDownList(list, 197443, 'Fugitive (2017)');
addItemToDropDownList(list, 318084, 'Furnace (2020)');
addItemToDropDownList(list, 171273, 'FUSE (2015)');
addItemToDropDownList(list, 220308, 'Gaia Project (2017)');
addItemToDropDownList(list, 391137, 'Galactic Cruise (2025)');
addItemToDropDownList(list, 31481, 'Galaxy Trucker (2007)');
addItemToDropDownList(list, 393333, 'Galileo Galilei (2024)');
addItemToDropDownList(list, 125153, 'The Gallerist (2015)');
addItemToDropDownList(list, 173090, 'The Game (2015)');
addItemToDropDownList(list, 39953, 'A Game of Thrones: The Card Game (2008)');
addItemToDropDownList(list, 42776, 'Gears of War: The Board Game (2011)');
addItemToDropDownList(list, 1345, 'Genoa (2001)');
addItemToDropDownList(list, 338376, 'A Gest of Robin Hood (2024)');
addItemToDropDownList(list, 347013, 'Get on Board: New York & London (2022)');
addItemToDropDownList(list, 83195, 'Ghost Blitz (2010)');
addItemToDropDownList(list, 37046, 'Ghost Stories (2008)');
addItemToDropDownList(list, 128271, 'Ginkgopolis (2012)');
addItemToDropDownList(list, 527, 'GIPF (1996)');
addItemToDropDownList(list, 246192, 'Gizmos (2018)');
addItemToDropDownList(list, 143693, 'Glass Road (2013)');
addItemToDropDownList(list, 66362, 'Glen More (2010)');
addItemToDropDownList(list, 265188, 'Glen More II: Chronicles (2019)');
addItemToDropDownList(list, 98527, 'Gloom of Kilforth: A Fantasy Quest Game (2017)');
addItemToDropDownList(list, 174430, 'Gloomhaven (2017)');
addItemToDropDownList(list, 393672, 'Gloomhaven: Buttons & Bugs (2024)');
addItemToDropDownList(list, 291457, 'Gloomhaven: Jaws of the Lion (2020)');
addItemToDropDownList(list, 19857, 'Glory to Rome (2005)');
addItemToDropDownList(list, 275044, 'Glow (2021)');
addItemToDropDownList(list, 188, 'Go (-2200)');
addItemToDropDownList(list, 9216, 'Goa (2004)');
addItemToDropDownList(list, 195539, 'The Godfather: Corleone`s Empire (2017)');
addItemToDropDownList(list, 154086, 'Gold West (2015)');
addItemToDropDownList(list, 182874, 'Grand Austria Hotel (2015)');
addItemToDropDownList(list, 929, 'The Great Dalmuti (1995)');
addItemToDropDownList(list, 292375, 'The Great Wall (2021)');
addItemToDropDownList(list, 193738, 'Great Western Trail (2016)');
addItemToDropDownList(list, 364011, 'Great Western Trail: Argentina (2022)');
addItemToDropDownList(list, 380607, 'Great Western Trail: New Zealand (2023)');
addItemToDropDownList(list, 111341, 'The Great Zimbabwe (2012)');
addItemToDropDownList(list, 171668, 'The Grizzled (2015)');
addItemToDropDownList(list, 267609, 'Guards of Atlantis II (2022)');
addItemToDropDownList(list, 250458, 'Gùgong (2018)');
addItemToDropDownList(list, 350933, 'The Guild of Merchant Explorers (2022)');
addItemToDropDownList(list, 132372, 'Guildhall (2012)');
addItemToDropDownList(list, 116, 'Guillotine (1998)');
addItemToDropDownList(list, 19100, 'Hacienda (2005)');
addItemToDropDownList(list, 269144, 'Hadara (2019)');
addItemToDropDownList(list, 304783, 'Hadrian`s Wall (2021)');
addItemToDropDownList(list, 37628, 'Haggis (2010)');
addItemToDropDownList(list, 300322, 'Hallertau (2020)');
addItemToDropDownList(list, 3685, 'Hammer of the Scots (2002)');
addItemToDropDownList(list, 98778, 'Hanabi (2010)');
addItemToDropDownList(list, 158600, 'Hanamikoji (2013)');
addItemToDropDownList(list, 234, 'Hannibal: Rome vs. Carthage (1996)');
addItemToDropDownList(list, 8989, 'Hansa (2004)');
addItemToDropDownList(list, 43015, 'Hansa Teutonica (2009)');
addItemToDropDownList(list, 223750, 'Hardback (2018)');
addItemToDropDownList(list, 414317, 'Harmonies (2024)');
addItemToDropDownList(list, 199042, 'Harry Potter: Hogwarts Battle (2016)');
addItemToDropDownList(list, 106217, 'Hawaii (2011)');
addItemToDropDownList(list, 366013, 'Heat: Pedal to the Metal (2022)');
addItemToDropDownList(list, 227789, 'Heaven & Ale (2017)');
addItemToDropDownList(list, 321608, 'Hegemony: Lead Your Class to Victory (2023)');
addItemToDropDownList(list, 243759, 'Hellboy: The Board Game (2019)');
addItemToDropDownList(list, 17392, 'Here I Stand (2006)');
addItemToDropDownList(list, 299252, 'Here to Slay (2020)');
addItemToDropDownList(list, 198994, 'Hero Realms (2016)');
addItemToDropDownList(list, 355326, 'Heroes of Might and Magic III: The Board Game (2024)');
addItemToDropDownList(list, 53093, 'Heroes of Normandie (2014)');
addItemToDropDownList(list, 699, 'HeroQuest (1989)');
addItemToDropDownList(list, 8203, 'Hey, That`s My Fish! (2003)');
addItemToDropDownList(list, 220, 'High Society (1995)');
addItemToDropDownList(list, 224, 'History of the World (1991)');
addItemToDropDownList(list, 2655, 'Hive (2001)');
addItemToDropDownList(list, 26566, 'Homesteaders (2009)');
addItemToDropDownList(list, 284742, 'Honey Buzz (2020)');
addItemToDropDownList(list, 282524, 'Horrified (2019)');
addItemToDropDownList(list, 350205, 'Horseless Carriage (2023)');
addItemToDropDownList(list, 134253, 'Hostage Negotiator (2015)');
addItemToDropDownList(list, 113873, 'The Hunters: German U-Boats at War, 1939-43 (2013)');
addItemToDropDownList(list, 198928, 'Iberia (2016)');
addItemToDropDownList(list, 177478, 'IKI (2015)');
addItemToDropDownList(list, 221, 'Ikusa (1986)');
addItemToDropDownList(list, 244995, 'Illusion (2018)');
addItemToDropDownList(list, 115, 'I`m the Boss! (1994)');
addItemToDropDownList(list, 191862, 'Imhotep (2016)');
addItemToDropDownList(list, 255674, 'Imhotep: The Duel (2018)');
addItemToDropDownList(list, 24181, 'Imperial (2006)');
addItemToDropDownList(list, 54138, 'Imperial 2030 (2009)');
addItemToDropDownList(list, 154203, 'Imperial Settlers (2014)');
addItemToDropDownList(list, 206480, 'Imperial Struggle (2020)');
addItemToDropDownList(list, 318184, 'Imperium: Classics (2021)');
addItemToDropDownList(list, 318182, 'Imperium: Legends (2021)');
addItemToDropDownList(list, 13780, 'In the Shadow of the Emperor (2004)');
addItemToDropDownList(list, 31594, 'In the Year of the Dragon (2007)');
addItemToDropDownList(list, 233678, 'Indian Summer (2017)');
addItemToDropDownList(list, 19777, 'Indonesia (2005)');
addItemToDropDownList(list, 9674, 'Ingenious (2004)');
addItemToDropDownList(list, 155821, 'Inis (2016)');
addItemToDropDownList(list, 63888, 'Innovation (2010)');
addItemToDropDownList(list, 347305, 'Inventions: Evolution of Ideas (2024)');
addItemToDropDownList(list, 281259, 'The Isle of Cats (2019)');
addItemToDropDownList(list, 176494, 'Isle of Skye: From Chieftain to King (2015)');
addItemToDropDownList(list, 185589, 'Islebound (2016)');
addItemToDropDownList(list, 325494, 'ISS Vanguard (2022)');
addItemToDropDownList(list, 148949, 'Istanbul (2014)');
addItemToDropDownList(list, 271324, 'It`s a Wonderful World (2019)');
addItemToDropDownList(list, 270109, 'Iwari (2020)');
addItemToDropDownList(list, 54043, 'Jaipur (2009)');
addItemToDropDownList(list, 28023, 'Jamaica (2007)');
addItemToDropDownList(list, 12002, 'Jambo (2004)');
addItemToDropDownList(list, 855, 'Java (2000)');
addItemToDropDownList(list, 297129, 'Jekyll vs. Hyde (2021)');
addItemToDropDownList(list, 205597, 'Jump Drive (2017)');
addItemToDropDownList(list, 193042, 'Junk Art (2016)');
addItemToDropDownList(list, 254640, 'Just One (2018)');
addItemToDropDownList(list, 73761, 'K2 (2010)');
addItemToDropDownList(list, 394, 'Kahuna (1998)');
addItemToDropDownList(list, 38545, 'Kamisado (2008)');
addItemToDropDownList(list, 284378, 'Kanban EV (2020)');
addItemToDropDownList(list, 109276, 'Kanban: Driver`s Edition (2014)');
addItemToDropDownList(list, 84732, 'Kariba (2010)');
addItemToDropDownList(list, 143175, 'Kashgar: Merchants of the Silk Road (2013)');
addItemToDropDownList(list, 127023, 'Kemet (2012)');
addItemToDropDownList(list, 297562, 'Kemet: Blood and Sand (2021)');
addItemToDropDownList(list, 122515, 'Keyflower (2012)');
addItemToDropDownList(list, 272453, 'KeyForge: Age of Ascension (2019)');
addItemToDropDownList(list, 257501, 'KeyForge: Call of the Archons (2018)');
addItemToDropDownList(list, 160499, 'King of New York (2014)');
addItemToDropDownList(list, 70323, 'King of Tokyo (2011)');
addItemToDropDownList(list, 293141, 'King of Tokyo: Dark Edition (2020)');
addItemToDropDownList(list, 107529, 'Kingdom Builder (2011)');
addItemToDropDownList(list, 55690, 'Kingdom Death: Monster (2015)');
addItemToDropDownList(list, 204583, 'Kingdomino (2016)');
addItemToDropDownList(list, 245655, 'The King`s Dilemma (2019)');
addItemToDropDownList(list, 27162, 'Kingsburg (2007)');
addItemToDropDownList(list, 223953, 'Kitchen Rush (2017)');
addItemToDropDownList(list, 165722, 'KLASK (2014)');
addItemToDropDownList(list, 181810, 'Kodama: The Tree Spirits (2016)');
addItemToDropDownList(list, 171879, 'Kraftwagen (2015)');
addItemToDropDownList(list, 196, 'Kremlin (1986)');
addItemToDropDownList(list, 266083, 'L.L.A.M.A. (2019)');
addItemToDropDownList(list, 554, 'La Città (2000)');
addItemToDropDownList(list, 146886, 'La Granja (2014)');
addItemToDropDownList(list, 57925, 'La Habana (2009)');
addItemToDropDownList(list, 154246, 'La Isla (2014)');
addItemToDropDownList(list, 62227, 'Labyrinth: The War on Terror, 2001 – ? (2010)');
addItemToDropDownList(list, 160851, 'Lanterns: The Harvest Festival (2015)');
addItemToDropDownList(list, 117959, 'Las Vegas (2012)');
addItemToDropDownList(list, 29368, 'Last Night on Earth: The Zombie Game (2007)');
addItemToDropDownList(list, 97842, 'Last Will (2011)');
addItemToDropDownList(list, 35677, 'Le Havre (2008)');
addItemToDropDownList(list, 129051, 'Le Havre: The Inland Port (2012)');
addItemToDropDownList(list, 173064, 'Leaving Earth (2015)');
addItemToDropDownList(list, 146652, 'Legendary Encounters: An Alien Deck Building Game (2014)');
addItemToDropDownList(list, 129437, 'Legendary: A Marvel Deck Building Game (2012)');
addItemToDropDownList(list, 127398, 'Legends of Andor (2012)');
addItemToDropDownList(list, 368173, 'Let`s Go! To Japan (2024)');
addItemToDropDownList(list, 59959, 'Letters from Whitechapel (2011)');
addItemToDropDownList(list, 137649, 'Level 7 [Omega Protocol] (2013)');
addItemToDropDownList(list, 140620, 'Lewis & Clark: The Expedition (2013)');
addItemToDropDownList(list, 125618, 'Libertalia (2012)');
addItemToDropDownList(list, 2507, 'Liberté (1998)');
addItemToDropDownList(list, 165872, 'Liberty or Death: The American Insurrection (2016)');
addItemToDropDownList(list, 153065, 'Linko (2014)');
addItemToDropDownList(list, 161533, 'Lisboa (2017)');
addItemToDropDownList(list, 134453, 'The Little Prince: Make Me a Planet (2013)');
addItemToDropDownList(list, 328479, 'Living Forest (2021)');
addItemToDropDownList(list, 240855, 'Lockup: A Roll Player Tale (2019)');
addItemToDropDownList(list, 65781, 'London (2010)');
addItemToDropDownList(list, 295374, 'Long Shot: The Dice Game (2022)');
addItemToDropDownList(list, 421006, 'The Lord of the Rings: Duel for Middle-earth (2024)');
addItemToDropDownList(list, 269385, 'The Lord of the Rings: Journeys in Middle-Earth (2019)');
addItemToDropDownList(list, 77423, 'The Lord of the Rings: The Card Game (2011)');
addItemToDropDownList(list, 349067, 'The Lord of the Rings: The Card Game – Revised Core Set (2022)');
addItemToDropDownList(list, 18833, 'The Lord of the Rings: The Confrontation (2005)');
addItemToDropDownList(list, 3201, 'Lord of the Rings: The Confrontation (2002)');
addItemToDropDownList(list, 222509, 'Lords of Hellas (2018)');
addItemToDropDownList(list, 20437, 'Lords of Vegas (2010)');
addItemToDropDownList(list, 110327, 'Lords of Waterdeep (2012)');
addItemToDropDownList(list, 156566, 'Lords of Xidit (2014)');
addItemToDropDownList(list, 203993, 'Lorenzo il Magnifico (2016)');
addItemToDropDownList(list, 50, 'Lost Cities (1999)');
addItemToDropDownList(list, 42487, 'Lost Cities: The Board Game (2008)');
addItemToDropDownList(list, 312484, 'Lost Ruins of Arnak (2020)');
addItemToDropDownList(list, 13642, 'Louis XIV (2005)');
addItemToDropDownList(list, 129622, 'Love Letter (2012)');
addItemToDropDownList(list, 168584, 'Love Letter: Batman (2015)');
addItemToDropDownList(list, 70512, 'Luna (2010)');
addItemToDropDownList(list, 245643, 'Luxor (2018)');
addItemToDropDownList(list, 55670, 'Macao (2009)');
addItemToDropDownList(list, 143884, 'Machi Koro (2012)');
addItemToDropDownList(list, 340364, 'Machi Koro 2 (2021)');
addItemToDropDownList(list, 95527, 'Madeira (2013)');
addItemToDropDownList(list, 96848, 'Mage Knight Board Game (2011)');
addItemToDropDownList(list, 101721, 'Mage Wars Arena (2012)');
addItemToDropDownList(list, 41916, 'The Magic Labyrinth (2009)');
addItemToDropDownList(list, 209778, 'Magic Maze (2017)');
addItemToDropDownList(list, 22, 'Magic Realm (1979)');
addItemToDropDownList(list, 463, 'Magic: The Gathering (1993)');
addItemToDropDownList(list, 2093, 'Mahjong (1850)');
addItemToDropDownList(list, 264241, 'Mandala (2019)');
addItemToDropDownList(list, 420077, 'The Mandalorian: Adventures (2024)');
addItemToDropDownList(list, 199, 'Manhattan (1994)');
addItemToDropDownList(list, 63628, 'The Manhattan Project (2012)');
addItemToDropDownList(list, 176734, 'The Manhattan Project: Energy Empire (2016)');
addItemToDropDownList(list, 15817, 'Manila (2005)');
addItemToDropDownList(list, 17396, 'Manoeuvre (2008)');
addItemToDropDownList(list, 83330, 'Mansions of Madness (2011)');
addItemToDropDownList(list, 148729, 'Maquis (2013)');
addItemToDropDownList(list, 276025, 'Maracaibo (2019)');
addItemToDropDownList(list, 283948, 'Marco Polo II: In the Service of the Khan (2019)');
addItemToDropDownList(list, 40354, 'Maria (2009)');
addItemToDropDownList(list, 297978, 'Mariposas (2020)');
addItemToDropDownList(list, 29223, 'Marrakech (2007)');
addItemToDropDownList(list, 342810, 'Marrakesh (2022)');
addItemToDropDownList(list, 285774, 'Marvel Champions: The Card Game (2019)');
addItemToDropDownList(list, 148575, 'Marvel Dice Masters: Avengers vs. X-Men (2014)');
addItemToDropDownList(list, 158275, 'Marvel Dice Masters: Uncanny X-Men (2014)');
addItemToDropDownList(list, 298047, 'Marvel United (2020)');
addItemToDropDownList(list, 336382, 'Marvel United: X-Men (2021)');
addItemToDropDownList(list, 181524, 'Masmorra: Dungeons of Arcadia (2017)');
addItemToDropDownList(list, 188547, 'Maximum Apocalypse (2018)');
addItemToDropDownList(list, 314491, 'Meadow (2021)');
addItemToDropDownList(list, 209010, 'Mechs vs. Minions (2016)');
addItemToDropDownList(list, 46, 'Medici (1995)');
addItemToDropDownList(list, 154386, 'Medieval Academy (2014)');
addItemToDropDownList(list, 1261, 'Medina (2001)');
addItemToDropDownList(list, 10630, 'Memoir `44 (2004)');
addItemToDropDownList(list, 244608, 'Menara (2018)');
addItemToDropDownList(list, 404431, 'Men-Nefer (2024)');
addItemToDropDownList(list, 230, 'Merchant of Venus (1988)');
addItemToDropDownList(list, 25292, 'Merchants & Marauders (2010)');
addItemToDropDownList(list, 238799, 'Messina 1347 (2021)');
addItemToDropDownList(list, 248861, 'Metro X (2018)');
addItemToDropDownList(list, 25568, 'Metropolys (2008)');
addItemToDropDownList(list, 2955, 'Mexica (2002)');
addItemToDropDownList(list, 124708, 'Mice and Mystics (2012)');
addItemToDropDownList(list, 318977, 'MicroMacro: Crime City (2020)');
addItemToDropDownList(list, 31563, 'Middle-Earth Quest (2009)');
addItemToDropDownList(list, 151347, 'Millennium Blades (2016)');
addItemToDropDownList(list, 244992, 'The Mind (2018)');
addItemToDropDownList(list, 284653, 'Mind MGMT: The Psychic Espionage “Game.” (2021)');
addItemToDropDownList(list, 345584, 'Mindbug: First Contact (2022)');
addItemToDropDownList(list, 200077, 'Mint Works (2017)');
addItemToDropDownList(list, 18258, 'Mission: Red Planet (2005)');
addItemToDropDownList(list, 118, 'Modern Art (1992)');
addItemToDropDownList(list, 172386, 'Mombasa (2015)');
addItemToDropDownList(list, 156546, 'Monikers (2015)');
addItemToDropDownList(list, 122298, 'Morels (2012)');
addItemToDropDownList(list, 175199, 'Mottainai (2015)');
addItemToDropDownList(list, 63975, 'Mountain Goats (2010)');
addItemToDropDownList(list, 21763, 'Mr. Jack (2006)');
addItemToDropDownList(list, 72287, 'Mr. Jack Pocket (2010)');
addItemToDropDownList(list, 152, 'Mü & More (1995)');
addItemToDropDownList(list, 163413, 'Murano (2014)');
addItemToDropDownList(list, 295486, 'My City (2020)');
addItemToDropDownList(list, 226320, 'My Little Scythe (2018)');
addItemToDropDownList(list, 21441, 'Mykerinos (2006)');
addItemToDropDownList(list, 126792, 'Myrmes (2012)');
addItemToDropDownList(list, 181304, 'Mysterium (2015)');
addItemToDropDownList(list, 915, 'Mystery of the Abbey (1995)');
addItemToDropDownList(list, 194607, 'Mystic Vale (2016)');
addItemToDropDownList(list, 186751, 'Mythic Battles: Pantheon (2017)');
addItemToDropDownList(list, 249746, 'Nanty Narking (2019)');
addItemToDropDownList(list, 18098, 'Napoleon`s Triumph (2007)');
addItemToDropDownList(list, 126042, 'Nations (2013)');
addItemToDropDownList(list, 157809, 'Nations: The Dice Game (2014)');
addItemToDropDownList(list, 66589, 'Navegador (2010)');
addItemToDropDownList(list, 195421, 'Near and Far (2017)');
addItemToDropDownList(list, 3072, 'Necromunda (1995)');
addItemToDropDownList(list, 167355, 'Nemesis (2018)');
addItemToDropDownList(list, 310100, 'Nemesis: Lockdown (2022)');
addItemToDropDownList(list, 72321, 'The Networks: Primetime (2016)');
addItemToDropDownList(list, 21241, 'Neuroshima Hex (2006)');
addItemToDropDownList(list, 205716, 'New Angeles (2016)');
addItemToDropDownList(list, 255692, 'New Frontiers (2018)');
addItemToDropDownList(list, 174660, 'New York 1901 (2015)');
addItemToDropDownList(list, 244711, 'Newton (2018)');
addItemToDropDownList(list, 353545, 'Next Station: London (2022)');
addItemToDropDownList(list, 293014, 'Nidavellir (2020)');
addItemToDropDownList(list, 904, 'Nightmare Productions (2000)');
addItemToDropDownList(list, 50768, 'Ninjato (2011)');
addItemToDropDownList(list, 154809, 'Nippon (2015)');
addItemToDropDownList(list, 68264, 'No Retreat! The Russian Front (2011)');
addItemToDropDownList(list, 12942, 'No Thanks! (2004)');
addItemToDropDownList(list, 194879, 'Not Alone (2016)');
addItemToDropDownList(list, 120523, 'Nothing Personal (2013)');
addItemToDropDownList(list, 25554, 'Notre Dame (2007)');
addItemToDropDownList(list, 284435, 'Nova Luna (2019)');
addItemToDropDownList(list, 396790, 'Nucleum (2023)');
addItemToDropDownList(list, 234277, 'Nusfjord (2017)');
addItemToDropDownList(list, 291572, 'Oath (2021)');
addItemToDropDownList(list, 251661, 'Oathsworn: Into the Deepwood (2022)');
addItemToDropDownList(list, 273477, 'Obscurio (2019)');
addItemToDropDownList(list, 231733, 'Obsession (2018)');
addItemToDropDownList(list, 232414, 'Oceans (2020)');
addItemToDropDownList(list, 270314, 'Ohanami (2019)');
addItemToDropDownList(list, 184267, 'On Mars (2020)');
addItemToDropDownList(list, 251412, 'On Tour (2019)');
addItemToDropDownList(list, 179275, 'One Deck Dungeon (2016)');
addItemToDropDownList(list, 147949, 'One Night Ultimate Werewolf (2014)');
addItemToDropDownList(list, 163166, 'One Night Ultimate Werewolf: Daybreak (2015)');
addItemToDropDownList(list, 71836, 'Onirim (2010)');
addItemToDropDownList(list, 160477, 'Onitama (2014)');
addItemToDropDownList(list, 70149, 'Ora et Labora (2011)');
addItemToDropDownList(list, 193558, 'The Oracle of Delphi (2016)');
addItemToDropDownList(list, 31497, 'Oregon (2007)');
addItemToDropDownList(list, 287084, 'Oriflamme (2019)');
addItemToDropDownList(list, 164928, 'Orléans (2014)');
addItemToDropDownList(list, 172047, 'The Others (2016)');
addItemToDropDownList(list, 172931, 'Outfoxed! (2014)');
addItemToDropDownList(list, 129948, 'The Palaces of Carrara (2012)');
addItemToDropDownList(list, 266810, 'Paladins of the West Kingdom (2019)');
addItemToDropDownList(list, 300531, 'Paleo (2020)');
addItemToDropDownList(list, 303057, 'Pan Am (2020)');
addItemToDropDownList(list, 30549, 'Pandemic (2008)');
addItemToDropDownList(list, 314040, 'Pandemic Legacy: Season 0 (2020)');
addItemToDropDownList(list, 161936, 'Pandemic Legacy: Season 1 (2015)');
addItemToDropDownList(list, 221107, 'Pandemic Legacy: Season 2 (2017)');
addItemToDropDownList(list, 150658, 'Pandemic: The Cure (2014)');
addItemToDropDownList(list, 141572, 'Paperback (2014)');
addItemToDropDownList(list, 56692, 'Parade (2007)');
addItemToDropDownList(list, 280136, 'Paranormal Detectives (2019)');
addItemToDropDownList(list, 266524, 'PARKS (2019)');
addItemToDropDownList(list, 163412, 'Patchwork (2014)');
addItemToDropDownList(list, 133038, 'Pathfinder Adventure Card Game: Rise of the Runelords – Base Set (2013)');
addItemToDropDownList(list, 91, 'Paths of Glory (1999)');
addItemToDropDownList(list, 219101, 'Pavlov`s House (2018)');
addItemToDropDownList(list, 128780, 'Pax Porfiriana (2012)');
addItemToDropDownList(list, 198953, 'Pax Renaissance (2016)');
addItemToDropDownList(list, 42910, 'Peloponnes (2009)');
addItemToDropDownList(list, 90040, 'Pergamon (2011)');
addItemToDropDownList(list, 45, 'Perudo (1800)');
addItemToDropDownList(list, 15818, 'Pick-omino (2005)');
addItemToDropDownList(list, 24480, 'The Pillars of the Earth (2006)');
addItemToDropDownList(list, 150, 'PitchCar (1995)');
addItemToDropDownList(list, 125548, 'Pixel Tactics (2012)');
addItemToDropDownList(list, 23094, 'Planet Steam (2008)');
addItemToDropDownList(list, 258779, 'Planet Unknown (2022)');
addItemToDropDownList(list, 1115, 'Poker (1810)');
addItemToDropDownList(list, 69779, 'Polis: Fight for the Hegemony (2012)');
addItemToDropDownList(list, 180899, 'Ponzi Scheme (2015)');
addItemToDropDownList(list, 156009, 'Port Royal (2014)');
addItemToDropDownList(list, 172385, 'Porta Nigra (2015)');
addItemToDropDownList(list, 180974, 'Potion Explosion (2015)');
addItemToDropDownList(list, 2651, 'Power Grid (2004)');
addItemToDropDownList(list, 155873, 'Power Grid Deluxe: Europe/North America (2014)');
addItemToDropDownList(list, 44163, 'Power Grid: Factory Manager (2009)');
addItemToDropDownList(list, 308765, 'Praga Caput Regni (2020)');
addItemToDropDownList(list, 87890, 'Prêt-à-Porter (2010)');
addItemToDropDownList(list, 555, 'The Princes of Florence (2000)');
addItemToDropDownList(list, 8045, 'Princes of the Renaissance (2003)');
addItemToDropDownList(list, 181796, 'The Prodigals Club (2015)');
addItemToDropDownList(list, 260180, 'Project L (2020)');
addItemToDropDownList(list, 3076, 'Puerto Rico (2002)');
addItemToDropDownList(list, 228341, 'Pulsar 2849 (2017)');
addItemToDropDownList(list, 181687, 'The Pursuit of Happiness (2015)');
addItemToDropDownList(list, 266830, 'QE (2019)');
addItemToDropDownList(list, 244521, 'Quacks (2018)');
addItemToDropDownList(list, 176396, 'Quadropolis (2016)');
addItemToDropDownList(list, 143519, 'Quantum (2013)');
addItemToDropDownList(list, 91536, 'Quarriors! (2011)');
addItemToDropDownList(list, 159473, 'Quartermaster General (2014)');
addItemToDropDownList(list, 681, 'Quarto (1991)');
addItemToDropDownList(list, 217372, 'The Quest for El Dorado (2017)');
addItemToDropDownList(list, 624, 'Quoridor (1997)');
addItemToDropDownList(list, 25669, 'Qwirkle (2006)');
addItemToDropDownList(list, 131260, 'Qwixx (2012)');
addItemToDropDownList(list, 12, 'Ra (1999)');
addItemToDropDownList(list, 254386, 'Raccoon Tycoon (2018)');
addItemToDropDownList(list, 28143, 'Race for the Galaxy (2007)');
addItemToDropDownList(list, 329082, 'Radlands (2021)');
addItemToDropDownList(list, 40209, 'RAF: The Battle of Britain 1940 (2009)');
addItemToDropDownList(list, 301880, 'Raiders of Scythia (2020)');
addItemToDropDownList(list, 170042, 'Raiders of the North Sea (2015)');
addItemToDropDownList(list, 251678, 'Railroad Ink: Blazing Red Edition (2018)');
addItemToDropDownList(list, 245654, 'Railroad Ink: Deep Blue Edition (2018)');
addItemToDropDownList(list, 17133, 'Railways of the World (2005)');
addItemToDropDownList(list, 366683, 'Raising Robots (2023)');
addItemToDropDownList(list, 220877, 'Rajas of the Ganges (2017)');
addItemToDropDownList(list, 318553, 'Rajas of the Ganges: The Dice Charmers (2020)');
addItemToDropDownList(list, 60435, 'Rallyman (2009)');
addItemToDropDownList(list, 256589, 'Rallyman: GT (2020)');
addItemToDropDownList(list, 42452, 'Rattus (2010)');
addItemToDropDownList(list, 351040, 'Ready Set Bet (2022)');
addItemToDropDownList(list, 242684, 'Reavers of Midgard (2019)');
addItemToDropDownList(list, 417197, 'Rebirth (2024)');
addItemToDropDownList(list, 227224, 'The Red Cathedral (2020)');
addItemToDropDownList(list, 161417, 'Red7 (2014)');
addItemToDropDownList(list, 12962, 'Reef Encounter (2004)');
addItemToDropDownList(list, 307002, 'Regicide (2020)');
addItemToDropDownList(list, 300001, 'Renature (2020)');
addItemToDropDownList(list, 1513, 'The Republic of Rome (1990)');
addItemToDropDownList(list, 262712, 'Res Arcana (2019)');
addItemToDropDownList(list, 41114, 'The Resistance (2009)');
addItemToDropDownList(list, 128882, 'The Resistance: Avalon (2012)');
addItemToDropDownList(list, 256680, 'Return to Dark Tower (2022)');
addItemToDropDownList(list, 332772, 'Revive (2022)');
addItemToDropDownList(list, 34887, 'Revolution! (2009)');
addItemToDropDownList(list, 104363, 'Rex: Final Days of an Empire (2012)');
addItemToDropDownList(list, 51, 'Ricochet Robots (1999)');
addItemToDropDownList(list, 297486, 'Ride the Rails (2020)');
addItemToDropDownList(list, 202583, 'Rise of Tribes (2018)');
addItemToDropDownList(list, 205896, 'Rising Sun (2018)');
addItemToDropDownList(list, 1829, 'Risk 2210 A.D. (2001)');
addItemToDropDownList(list, 105134, 'Risk Legacy (2011)');
addItemToDropDownList(list, 183880, 'Risk: Star Wars Edition (2015)');
addItemToDropDownList(list, 66056, 'Rivals for Catan (2010)');
addItemToDropDownList(list, 227515, 'Riverboat (2017)');
addItemToDropDownList(list, 121921, 'Robinson Crusoe: Adventures on the Cursed Island (2012)');
addItemToDropDownList(list, 216201, 'Robo Rally (2016)');
addItemToDropDownList(list, 18, 'RoboRally (1994)');
addItemToDropDownList(list, 144344, 'Rococo (2013)');
addItemToDropDownList(list, 132531, 'Roll for the Galaxy (2014)');
addItemToDropDownList(list, 169426, 'Roll Player (2016)');
addItemToDropDownList(list, 37380, 'Roll Through the Ages: The Bronze Age (2008)');
addItemToDropDownList(list, 127024, 'Room 25 (2013)');
addItemToDropDownList(list, 237182, 'Root (2018)');
addItemToDropDownList(list, 201, 'The Rose King (1992)');
addItemToDropDownList(list, 165986, 'Royals (2014)');
addItemToDropDownList(list, 196202, 'Rum & Bones: Second Tide (2017)');
addItemToDropDownList(list, 811, 'Rummikub (1977)');
addItemToDropDownList(list, 59294, 'Runewars (2010)');
addItemToDropDownList(list, 228328, 'Rurik: Dawn of Kiev (2019)');
addItemToDropDownList(list, 144733, 'Russian Railroads (2013)');
addItemToDropDownList(list, 9220, 'Saboteur (2004)');
addItemToDropDownList(list, 309105, 'Sagani (2020)');
addItemToDropDownList(list, 199561, 'Sagrada (2017)');
addItemToDropDownList(list, 9217, 'Saint Petersburg (2004)');
addItemToDropDownList(list, 402663, 'Salton Sea (2024)');
addItemToDropDownList(list, 3, 'Samurai (1998)');
addItemToDropDownList(list, 8217, 'San Juan (2004)');
addItemToDropDownList(list, 1041, 'San Marco (2001)');
addItemToDropDownList(list, 229220, 'Santa Maria (2017)');
addItemToDropDownList(list, 298065, 'Santa Monica (2020)');
addItemToDropDownList(list, 8125, 'Santiago (2003)');
addItemToDropDownList(list, 104347, 'Santiago de Cuba (2011)');
addItemToDropDownList(list, 194655, 'Santorini (2016)');
addItemToDropDownList(list, 372, 'Schotten Totten (1999)');
addItemToDropDownList(list, 438, 'Scotland Yard (1983)');
addItemToDropDownList(list, 291453, 'SCOUT (2019)');
addItemToDropDownList(list, 145659, 'Scoville (2014)');
addItemToDropDownList(list, 169786, 'Scythe (2016)');
addItemToDropDownList(list, 367220, 'Sea Salt & Paper (2022)');
addItemToDropDownList(list, 279537, 'The Search for Planet X (2020)');
addItemToDropDownList(list, 108745, 'Seasons (2012)');
addItemToDropDownList(list, 188834, 'Secret Hitler (2016)');
addItemToDropDownList(list, 25021, 'Sekigahara: The Unification of Japan (2011)');
addItemToDropDownList(list, 102652, 'Sentinels of the Multiverse (2011)');
addItemToDropDownList(list, 1198, 'SET (1988)');
addItemToDropDownList(list, 228855, 'Set a Watch (2019)');
addItemToDropDownList(list, 418059, 'SETI: Search for Extraterrestrial Intelligence (2024)');
addItemToDropDownList(list, 15062, 'Shadows over Camelot (2005)');
addItemToDropDownList(list, 244115, 'Shards of Infinity (2018)');
addItemToDropDownList(list, 157969, 'Sheriff of Nottingham (2014)');
addItemToDropDownList(list, 204305, 'Sherlock Holmes Consulting Detective: Jack the Ripper & West End Adventures (2016)');
addItemToDropDownList(list, 2511, 'Sherlock Holmes Consulting Detective: The Thames Murders & Other Cases (1981)');
addItemToDropDownList(list, 23540, 'Shikoku 1889 (2004)');
addItemToDropDownList(list, 220517, 'The Shipwreck Arcana (2017)');
addItemToDropDownList(list, 55600, 'Shipyard (2009)');
addItemToDropDownList(list, 272380, 'SHOBU (2019)');
addItemToDropDownList(list, 2065, 'Shogi (1587)');
addItemToDropDownList(list, 20551, 'Shogun (2006)');
addItemToDropDownList(list, 77130, 'Sid Meier`s Civilization: The Board Game (2010)');
addItemToDropDownList(list, 202426, 'Sidereal Confluence (2017)');
addItemToDropDownList(list, 177678, 'Signorie (2015)');
addItemToDropDownList(list, 268620, 'Similo (2019)');
addItemToDropDownList(list, 92415, 'Skull (2011)');
addItemToDropDownList(list, 150145, 'Skull King (2013)');
addItemToDropDownList(list, 373106, 'Sky Team (2023)');
addItemToDropDownList(list, 298231, 'Skyrise (2024)');
addItemToDropDownList(list, 338960, 'Slay the Spire: The Board Game (2024)');
addItemToDropDownList(list, 255984, 'Sleeping Gods (2021)');
addItemToDropDownList(list, 594, 'Sleuth (1971)');
addItemToDropDownList(list, 40692, 'Small World (2009)');
addItemToDropDownList(list, 97786, 'Small World Underground (2011)');
addItemToDropDownList(list, 246684, 'Smartphone Inc. (2018)');
addItemToDropDownList(list, 122522, 'Smash Up (2012)');
addItemToDropDownList(list, 134726, 'Smash Up: Awesome Level 9000 (2013)');
addItemToDropDownList(list, 177802, 'Smash Up: It`s Your Fault! (2016)');
addItemToDropDownList(list, 119432, 'Snowdonia (2012)');
addItemToDropDownList(list, 329839, 'So Clover! (2021)');
addItemToDropDownList(list, 332944, 'Sobek: 2 Players (2021)');
addItemToDropDownList(list, 38453, 'Space Alert (2008)');
addItemToDropDownList(list, 242302, 'Space Base (2018)');
addItemToDropDownList(list, 1568, 'Space Crusade (1990)');
addItemToDropDownList(list, 84419, 'Space Empires 4X (2011)');
addItemToDropDownList(list, 2163, 'Space Hulk (1989)');
addItemToDropDownList(list, 71721, 'Space Hulk: Death Angel – The Card Game (2010)');
addItemToDropDownList(list, 356414, 'Space Station Phoenix (2022)');
addItemToDropDownList(list, 214029, 'SpaceCorp: 2025-2300AD (2018)');
addItemToDropDownList(list, 128671, 'Spartacus: A Game of Blood and Treachery (2012)');
addItemToDropDownList(list, 375459, 'Speakeasy (2025)');
addItemToDropDownList(list, 415147, 'Spectacular (2024)');
addItemToDropDownList(list, 66505, 'The Speicherstadt (2010)');
addItemToDropDownList(list, 162886, 'Spirit Island (2017)');
addItemToDropDownList(list, 148228, 'Splendor (2014)');
addItemToDropDownList(list, 364073, 'Splendor Duel (2022)');
addItemToDropDownList(list, 63268, 'Spot it! (2009)');
addItemToDropDownList(list, 251658, 'Sprawlopolis (2018)');
addItemToDropDownList(list, 166384, 'Spyfall (2014)');
addItemToDropDownList(list, 193308, 'Spyfall 2 (2016)');
addItemToDropDownList(list, 137269, 'Spyrium (2013)');
addItemToDropDownList(list, 1035, 'Squad Leader (1977)');
addItemToDropDownList(list, 147020, 'Star Realms (2014)');
addItemToDropDownList(list, 182631, 'Star Realms: Colony Wars (2015)');
addItemToDropDownList(list, 230253, 'Star Realms: Frontiers (2018)');
addItemToDropDownList(list, 193949, 'Star Trek: Ascendancy (2016)');
addItemToDropDownList(list, 117985, 'Star Trek: Catan (2012)');
addItemToDropDownList(list, 79127, 'Star Trek: Fleet Captains (2011)');
addItemToDropDownList(list, 163745, 'Star Wars: Armada (2015)');
addItemToDropDownList(list, 3284, 'Star Wars: Epic Duels (2002)');
addItemToDropDownList(list, 164153, 'Star Wars: Imperial Assault (2014)');
addItemToDropDownList(list, 353470, 'Star Wars: Jabba`s Palace – A Love Letter Game (2022)');
addItemToDropDownList(list, 271896, 'Star Wars: Outer Rim (2019)');
addItemToDropDownList(list, 187645, 'Star Wars: Rebellion (2016)');
addItemToDropDownList(list, 103886, 'Star Wars: The Card Game (2012)');
addItemToDropDownList(list, 374173, 'Star Wars: The Deckbuilding Game (2023)');
addItemToDropDownList(list, 939, 'Star Wars: The Queen`s Gambit (2000)');
addItemToDropDownList(list, 387866, 'Star Wars: Unlimited (2024)');
addItemToDropDownList(list, 312267, 'Star Wars: Unlock! (2020)');
addItemToDropDownList(list, 103885, 'Star Wars: X-Wing Miniatures Game (2012)');
addItemToDropDownList(list, 22827, 'StarCraft: The Board Game (2007)');
addItemToDropDownList(list, 1897, 'The Starfarers of Catan (1999)');
addItemToDropDownList(list, 223770, 'Startups (2017)');
addItemToDropDownList(list, 27833, 'Steam (2009)');
addItemToDropDownList(list, 162007, 'Steampunk Rally (2015)');
addItemToDropDownList(list, 329845, 'Stella: Dixit Universe (2021)');
addItemToDropDownList(list, 161614, 'Stockpile (2015)');
addItemToDropDownList(list, 34635, 'Stone Age (2008)');
addItemToDropDownList(list, 9625, 'Struggle of Empires (2004)');
addItemToDropDownList(list, 141517, 'A Study in Emerald (2013)');
addItemToDropDownList(list, 204472, 'Sub Terra (2017)');
addItemToDropDownList(list, 123260, 'Suburbia (2012)');
addItemToDropDownList(list, 58281, 'Summoner Wars (2009)');
addItemToDropDownList(list, 93260, 'Summoner Wars: Master Set (2011)');
addItemToDropDownList(list, 18745, 'Sun Tzu (2005)');
addItemToDropDownList(list, 194517, 'Super Fantasy Brawl (2022)');
addItemToDropDownList(list, 2653, 'Survive: Escape from Atlantis! (1982)');
addItemToDropDownList(list, 192291, 'Sushi Go Party! (2016)');
addItemToDropDownList(list, 133473, 'Sushi Go! (2013)');
addItemToDropDownList(list, 271869, 'Sushi Roll (2019)');
addItemToDropDownList(list, 170771, 'Sword & Sorcery: Immortal Souls (2017)');
addItemToDropDownList(list, 7480, 'Sword of Rome: Conquest of Italy, 362-272 BC (2004)');
addItemToDropDownList(list, 143405, 'Sylvion (2015)');
addItemToDropDownList(list, 146508, 'T.I.M.E Stories (2015)');
addItemToDropDownList(list, 264220, 'Tainted Grail: The Fall of Avalon (2019)');
addItemToDropDownList(list, 475, 'Taj Mahal (2000)');
addItemToDropDownList(list, 197405, 'Tak (2017)');
addItemToDropDownList(list, 70919, 'Takenoko (2011)');
addItemToDropDownList(list, 34119, 'Tales of the Arabian Nights (2009)');
addItemToDropDownList(list, 24508, 'Taluva (2006)');
addItemToDropDownList(list, 30645, 'Tammany Hall (2007)');
addItemToDropDownList(list, 252153, 'Tang Garden (2019)');
addItemToDropDownList(list, 286096, 'Tapestry (2019)');
addItemToDropDownList(list, 118048, 'Targi (2012)');
addItemToDropDownList(list, 146278, 'Tash-Kalar: Arena of Legends (2013)');
addItemToDropDownList(list, 269207, 'The Taverns of Tiefenthal (2019)');
addItemToDropDownList(list, 297030, 'Tekhenu: Obelisk of the Sun (2020)');
addItemToDropDownList(list, 46213, 'Telestrations (2009)');
addItemToDropDownList(list, 229853, 'Teotihuacan: City of Gods (2018)');
addItemToDropDownList(list, 120677, 'Terra Mystica (2012)');
addItemToDropDownList(list, 167791, 'Terraforming Mars (2016)');
addItemToDropDownList(list, 328871, 'Terraforming Mars: Ares Expedition (2021)');
addItemToDropDownList(list, 244522, 'That`s Pretty Clever! (2018)');
addItemToDropDownList(list, 188920, 'This War of Mine: The Board Game (2017)');
addItemToDropDownList(list, 145371, 'Three Kingdoms Redux (2014)');
addItemToDropDownList(list, 182028, 'Through the Ages: A New Story of Civilization (2015)');
addItemToDropDownList(list, 25613, 'Through the Ages: A Story of Civilization (2006)');
addItemToDropDownList(list, 503, 'Through the Desert (1998)');
addItemToDropDownList(list, 108906, 'Thunder Alley (2014)');
addItemToDropDownList(list, 342070, 'Thunder Road: Vendetta (2023)');
addItemToDropDownList(list, 160610, 'Thunderbirds (2015)');
addItemToDropDownList(list, 53953, 'Thunderstone (2009)');
addItemToDropDownList(list, 215341, 'Thunderstone Quest (2018)');
addItemToDropDownList(list, 21790, 'Thurn and Taxis (2006)');
addItemToDropDownList(list, 215, 'Tichu (1991)');
addItemToDropDownList(list, 9209, 'Ticket to Ride (2004)');
addItemToDropDownList(list, 390092, 'Ticket to Ride Legacy: Legends of the West (2023)');
addItemToDropDownList(list, 14996, 'Ticket to Ride: Europe (2005)');
addItemToDropDownList(list, 276894, 'Ticket to Ride: London (2019)');
addItemToDropDownList(list, 21348, 'Ticket to Ride: Märklin (2006)');
addItemToDropDownList(list, 253284, 'Ticket to Ride: New York (2018)');
addItemToDropDownList(list, 31627, 'Ticket to Ride: Nordic Countries (2007)');
addItemToDropDownList(list, 202670, 'Ticket to Ride: Rails & Sails (2016)');
addItemToDropDownList(list, 22825, 'Tide of Iron (2007)');
addItemToDropDownList(list, 176229, 'Tides of Time (2015)');
addItemToDropDownList(list, 42, 'Tigris & Euphrates (1997)');
addItemToDropDownList(list, 54, 'Tikal (1999)');
addItemToDropDownList(list, 351913, 'Tiletum (2022)');
addItemToDropDownList(list, 164949, 'Time of Crisis: The Roman Empire in Turmoil, 235-284 AD (2017)');
addItemToDropDownList(list, 113401, 'Timeline: Events (2011)');
addItemToDropDownList(list, 85256, 'Timeline: Inventions (2010)');
addItemToDropDownList(list, 1353, 'Time`s Up! (1999)');
addItemToDropDownList(list, 38713, 'Time`s Up! Party (2008)');
addItemToDropDownList(list, 35570, 'Tinners` Trail (2008)');
addItemToDropDownList(list, 331787, 'Tiny Epic Dungeons (2021)');
addItemToDropDownList(list, 163967, 'Tiny Epic Galaxies (2015)');
addItemToDropDownList(list, 148951, 'Tiny Epic Kingdoms (2014)');
addItemToDropDownList(list, 201921, 'Tiny Epic Quest (2017)');
addItemToDropDownList(list, 265736, 'Tiny Towns (2019)');
addItemToDropDownList(list, 103, 'Titan (1980)');
addItemToDropDownList(list, 42215, 'Tobago (2009)');
addItemToDropDownList(list, 123540, 'Tokaido (2012)');
addItemToDropDownList(list, 192135, 'Too Many Bones (2017)');
addItemToDropDownList(list, 235802, 'Too Many Bones: Undertow (2018)');
addItemToDropDownList(list, 88, 'Torres (1999)');
addItemToDropDownList(list, 218530, 'Tortuga 1667 (2017)');
addItemToDropDownList(list, 105037, 'Tournay (2011)');
addItemToDropDownList(list, 338628, 'Trails (2021)');
addItemToDropDownList(list, 102680, 'Trajan (2011)');
addItemToDropDownList(list, 166571, 'Tramways (2016)');
addItemToDropDownList(list, 288513, 'Tranquility (2020)');
addItemToDropDownList(list, 2842, 'TransAmerica (2001)');
addItemToDropDownList(list, 242639, 'Treasure Island (2018)');
addItemToDropDownList(list, 300442, 'Trekking the World (2020)');
addItemToDropDownList(list, 163068, 'Trickerion: Legends of Illusion (2015)');
addItemToDropDownList(list, 281442, 'Trismegistus: The Ultimate Formula (2019)');
addItemToDropDownList(list, 73439, 'Troyes (2010)');
addItemToDropDownList(list, 284584, 'Troyes Dice (2020)');
addItemToDropDownList(list, 16992, 'Tsuro (2005)');
addItemToDropDownList(list, 356123, 'Turing Machine (2022)');
addItemToDropDownList(list, 1403, 'Turn the Tide (1997)');
addItemToDropDownList(list, 257614, 'Tussie Mussie (2019)');
addItemToDropDownList(list, 269210, 'Twice as Clever! (2019)');
addItemToDropDownList(list, 12333, 'Twilight Struggle (2005)');
addItemToDropDownList(list, 134352, 'Two Rooms and a Boom (2013)');
addItemToDropDownList(list, 189932, 'Tyrants of the Underdark (2016)');
addItemToDropDownList(list, 31999, 'TZAAR (2007)');
addItemToDropDownList(list, 126163, 'Tzolk`in: The Mayan Calendar (2012)');
addItemToDropDownList(list, 16986, 'Ubongo (2003)');
addItemToDropDownList(list, 191876, 'Ulm (2016)');
addItemToDropDownList(list, 329500, 'Unconscious Mind (2024)');
addItemToDropDownList(list, 268864, 'Undaunted: Normandy (2019)');
addItemToDropDownList(list, 290359, 'Undaunted: North Africa (2020)');
addItemToDropDownList(list, 306735, 'Under Falling Skies (2020)');
addItemToDropDownList(list, 247763, 'Underwater Cities (2018)');
addItemToDropDownList(list, 217085, 'Unearth (2017)');
addItemToDropDownList(list, 179172, 'Unfair (2017)');
addItemToDropDownList(list, 274637, 'Unmatched: Battle of Legends, Volume One (2019)');
addItemToDropDownList(list, 294484, 'Unmatched: Cobble & Fog (2020)');
addItemToDropDownList(list, 274638, 'Unmatched: Robin Hood vs. Bigfoot (2019)');
addItemToDropDownList(list, 586, 'Up Front (1983)');
addItemToDropDownList(list, 361241, 'Vaalbara (2022)');
addItemToDropDownList(list, 170561, 'Valeria: Card Kingdoms (2016)');
addItemToDropDownList(list, 150999, 'Valley of the Kings (2014)');
addItemToDropDownList(list, 420033, 'Vantage (2025)');
addItemToDropDownList(list, 104020, 'Vanuatu (2011)');
addItemToDropDownList(list, 170416, 'Vast: The Crystal Caverns (2016)');
addItemToDropDownList(list, 15364, 'Vegas Showdown (2005)');
addItemToDropDownList(list, 157526, 'Viceroy (2014)');
addItemToDropDownList(list, 27173, 'Vikings (2007)');
addItemToDropDownList(list, 187377, 'Vikings Gone Wild (2017)');
addItemToDropDownList(list, 104006, 'Village (2011)');
addItemToDropDownList(list, 241724, 'Villagers (2019)');
addItemToDropDownList(list, 180040, 'Villages of Valeria (2017)');
addItemToDropDownList(list, 60, 'Vinci (1999)');
addItemToDropDownList(list, 224783, 'Vindication (2018)');
addItemToDropDownList(list, 42052, 'Vinhos (2010)');
addItemToDropDownList(list, 175640, 'Vinhos: Deluxe Edition (2016)');
addItemToDropDownList(list, 41066, 'Virgin Queen (2012)');
addItemToDropDownList(list, 296151, 'Viscounts of the West Kingdom (2020)');
addItemToDropDownList(list, 128621, 'Viticulture (2013)');
addItemToDropDownList(list, 183394, 'Viticulture Essential Edition (2015)');
addItemToDropDownList(list, 337627, 'Voidfall (2023)');
addItemToDropDownList(list, 171623, 'The Voyages of Marco Polo (2015)');
addItemToDropDownList(list, 31730, 'Wabash Cannonball (2007)');
addItemToDropDownList(list, 3307, 'Wallenstein (2002)');
addItemToDropDownList(list, 249259, 'War Chest (2018)');
addItemToDropDownList(list, 9609, 'War of the Ring (2004)');
addItemToDropDownList(list, 253499, 'A War of Whispers (2019)');
addItemToDropDownList(list, 156776, 'Warhammer 40,000: Conquest (2014)');
addItemToDropDownList(list, 1634, 'Warhammer Quest (1995)');
addItemToDropDownList(list, 224597, 'Warhammer Underworlds: Shadespire (2017)');
addItemToDropDownList(list, 38996, 'Washington`s War (2010)');
addItemToDropDownList(list, 274364, 'Watergate (2019)');
addItemToDropDownList(list, 262543, 'Wavelength (2019)');
addItemToDropDownList(list, 350316, 'Wayfarers of the South Tigris (2022)');
addItemToDropDownList(list, 237179, 'Weather Machine (2022)');
addItemToDropDownList(list, 491, 'Web of Power (2000)');
addItemToDropDownList(list, 195043, 'Welcome Back to the Dungeon (2016)');
addItemToDropDownList(list, 150312, 'Welcome to the Dungeon (2013)');
addItemToDropDownList(list, 339789, 'Welcome to the Moon (2021)');
addItemToDropDownList(list, 233867, 'Welcome To... (2018)');
addItemToDropDownList(list, 25821, 'The Werewolves of Miller`s Hollow (2001)');
addItemToDropDownList(list, 232405, 'Western Legends (2018)');
addItemToDropDownList(list, 198454, 'When I Dream (2016)');
addItemToDropDownList(list, 301255, 'Whistle Mountain (2020)');
addItemToDropDownList(list, 371942, 'The White Castle (2023)');
addItemToDropDownList(list, 1822, 'Wilderness War (2001)');
addItemToDropDownList(list, 266192, 'Wingspan (2019)');
addItemToDropDownList(list, 366161, 'Wingspan Asia (2022)');
addItemToDropDownList(list, 1382, 'Winner`s Circle (2001)');
addItemToDropDownList(list, 165401, 'Wir sind das Volk! (2014)');
addItemToDropDownList(list, 331106, 'The Witcher: Old World (2023)');
addItemToDropDownList(list, 164265, 'Witness (2014)');
addItemToDropDownList(list, 20100, 'Wits & Wagers (2005)');
addItemToDropDownList(list, 1465, 'Wizard (1984)');
addItemToDropDownList(list, 227935, 'Wonderland`s War (2022)');
addItemToDropDownList(list, 400366, 'Wondrous Creatures (2024)');
addItemToDropDownList(list, 355093, 'Woodcraft (2022)');
addItemToDropDownList(list, 17223, 'World of Warcraft: The Boardgame (2005)');
addItemToDropDownList(list, 43528, 'World Without End (2009)');
addItemToDropDownList(list, 878, 'Wyatt Earp (2001)');
addItemToDropDownList(list, 410201, 'Wyrmspan (2024)');
addItemToDropDownList(list, 159109, 'XenoShyft: Onslaught (2015)');
addItemToDropDownList(list, 82222, 'Xia: Legends of a Drift System (2014)');
addItemToDropDownList(list, 213893, 'Yamataï (2017)');
addItemToDropDownList(list, 117915, 'Yedo (2012)');
addItemToDropDownList(list, 244114, 'Yellow & Yangtze (2018)');
addItemToDropDownList(list, 71671, 'Yggdrasil (2011)');
addItemToDropDownList(list, 7854, 'YINSH (2003)');
addItemToDropDownList(list, 196340, 'Yokohama (2016)');
addItemToDropDownList(list, 22345, 'Yspahan (2006)');
addItemToDropDownList(list, 6830, 'Zendo (2001)');
addItemToDropDownList(list, 528, 'ZÈRTZ (1999)');
addItemToDropDownList(list, 160495, 'ZhanGuo (2014)');
addItemToDropDownList(list, 113924, 'Zombicide (2012)');
addItemToDropDownList(list, 176189, 'Zombicide: Black Plague (2015)');
addItemToDropDownList(list, 368061, 'Zoo Vadis (2023)');
addItemToDropDownList(list, 27588, 'Zooloretto (2007)');

}